import axios, { type AxiosInstance } from "axios"

export const DEFAULT_ACCOUNT_TOKEN_HEADER = "x-account-token"
export const DEFAULT_ROLE_TOKEN_HEADER = "x-role-token"

/**
 * createRequest —— 创建 axios 实例，带基础的 request/response 拦截器
 * 不再自动挂载 mock interceptor
 */
export const createRequest = (option?: {
    requestOption?: Record<string, unknown>
    sdkReady?: unknown
}): AxiosInstance => {
    const requestOption =
        option?.requestOption ?? (option as Record<string, unknown>)
    const instance = axios.create({
        responseType: "json",
        timeout: 5000,
        ...requestOption,
    })

    instance.interceptors.request.use(
        (config) => {
            document.body.classList.add("wait")
            return config
        },
        (error) => {
            document.body.classList.remove("wait")
            return Promise.reject(error)
        },
    )

    instance.interceptors.response.use(
        (response) => {
            document.body.classList.remove("wait")
            return response.data ?? response
        },
        (error) => {
            document.body.classList.remove("wait")
            return Promise.reject(error)
        },
    )

    return instance
}

// 保留空壳导出以防止其他 libs 内部引用报错
export const useRole = () => ({ role: null, loading: false })
export const useRoleMeta = () => null
export const useAccount = () => ({ account: null, ready: false })
export const useAccountLogout = () => () => {}
export const useRoleLogout = () => () => {}
export const useShowChannelSelect = () => () => {}
export const useShowRoleSelect = () => () => {}

export const OneAccount = {
    hooks: {
        useShowLoginDialog: () => () => {},
        useAccount: () => ({ account: null, ready: false }),
    },
}

export const RoleProvider = ({
    children,
}: { children: React.ReactNode }) => <>{children}</>
